export default __webpack_public_path__ + "static/media/smartSearch_ru_d.1b4bf041.svg";